module.exports = new __parcel__URL__("divineempowerment.a2a14275.png").toString();